'use strict';

var slicedToArray = require('./../../external/@babel/runtime/helpers/esm/slicedToArray.js');
var React = require('react');

var useIsOverflow = function useIsOverflow(ref) {
  var _useState = React.useState({
      overflow: false,
      height: 0
    }),
    _useState2 = slicedToArray.default(_useState, 2),
    isOverflow = _useState2[0],
    setIsOverflow = _useState2[1];
  React.useEffect(function () {
    handleResize();
    function handleResize() {
      var _ref$current, _ref$current2;
      var scrollHeight = ref === null || ref === void 0 ? void 0 : (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.scrollHeight;
      var offsetHeight = ref === null || ref === void 0 ? void 0 : (_ref$current2 = ref.current) === null || _ref$current2 === void 0 ? void 0 : _ref$current2.offsetHeight;
      setIsOverflow({
        overflow: offsetHeight < scrollHeight,
        height: scrollHeight
      });
    }
    window.addEventListener('resize', handleResize);
    return function () {
      return window.removeEventListener('resize', handleResize);
    };
  }, []);
  return isOverflow;
};

exports.useIsOverflow = useIsOverflow;
//# sourceMappingURL=useIsOverflow.js.map
